var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section newsletter-section"},[(_vm.loggedInUser)?_c('HgNewsletterBox',{attrs:{"loading":_vm.loading,"success":_vm.success,"user-e-mail":_vm.loggedInUser.email},on:{"onSubscribe":_vm.subscribe}}):_c('HgNewsletterBox',{attrs:{"loading":_vm.loading,"success":_vm.success},on:{"onSubscribe":_vm.subscribe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }